<template>
  <el-dialog :title="$t('system.user.changePassword')" v-model="dialogPassword" :modal="true" :append-to-body="true">
    <el-form ref="passwordFormRef" class="dialog-form" :model="passwordForm" :rules="passwordFormRules" :label-width="curLang == 'zh-CN' ? '100px' : '150px'">
      <div v-if="passExpireDate && passExpireDate !== 'undefined' && passExpireDate !== 'null'">
        <el-alert
          style="margin-bottom: 12px;"
          :title="`${$t('system.user.withDate')}${passExpireDate}${$t('system.user.withDate1')}`"
          type="error"
          :closable="false">
        </el-alert>
      </div>
      <el-form-item :label="$t('system.user.newPasswordColon')" prop="password">
        <el-input :placeholder="$t('system.user.enterNewPassword')" v-model="passwordForm.password" show-password @input="checkCustomStrength">
        </el-input>
      </el-form-item>
      <el-form-item v-if="passwordForm.password !== ''">
        <div class="strength-meter">
          <div class="strength-fill" :style="customStrengthStyle"></div>
        </div>
        <!-- <div class="strength-labels">
          <span>非常弱</span>
          <span>弱</span>
          <span>一般</span>
          <span>强</span>
          <span>非常强</span>
        </div> -->
        <!-- <div class="strength-text" :style="{color: customStrengthColor}">
          {{ customStrengthText }}
        </div> -->
      </el-form-item>
      <el-form-item :label="$t('system.user.confirmPasswordColon')" prop="confirmPass">
        <el-input :placeholder="$t('system.user.reEnterNewPassword')" v-model="passwordForm.confirmPass" show-password>
        </el-input>
      </el-form-item>
      <!-- <el-form-item label="" style="color: #D80C1E;">{{$t('system.user.passwordRequirement')}}</el-form-item> -->
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" size="mini" @click="onSubmit">{{$t('activity.list.confirm')}}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { ref, reactive, watch, computed } from "vue";
import {   
} from '../form/formItem'
import { useStore } from "vuex"
import { validatePassword, validateConfirmPass } from '@/utils/formValidate.js'
import { useI18n } from 'vue-i18n'
import { request } from "@/utils/request";
import { ElMessage } from "element-plus";
export default {
  components: {
  },
  props: {
    modelValue: {
      type: [Array, Object],
      required: true,
    },
    params: {
      type: [Array, Object],
      required: true,
    },
    dialogOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { t } = useI18n()
    const store = useStore()
    const lan = store.state.lang
    const dialogPassword = ref(props.dialogOpen)
    const isPasswordValid = window.localStorage.getItem('isPasswordValid')
    const passExpireDate = window.localStorage.getItem('passExpireDate')
    const passwordFormRef = ref(null)
    const passwordForm = reactive({
      password: '',
      confirmPass: '',
      userId: props.params?.userId || null,
    })
    const passwordFormRules = reactive({
      password: [{
          required: true,
          message: t('system.user.enterNewPassword'),
          trigger: 'change'
        },
        {
          validator: validatePassword,
          trigger: 'blur',
        }
      ],
      confirmPass: [{
          required: true,
          message: t('system.user.reEnterNewPassword'),
          trigger: 'change'
        },
        {
          validator: validateConfirmPass(passwordForm),
          trigger: 'blur',
        }
      ]
    })

    const customStrength = ref(0)
    // 计算属性
    const hasUpperCase = computed(() => {
      return /[A-Z]/.test(passwordForm.password)
    })
    
    const hasLowerCase = computed(() => {
      return /[a-z]/.test(passwordForm.password)
    })
    
    const hasNumber = computed(() => {
      return /[0-9]/.test(passwordForm.password)
    })
    
    const hasSpecialChar = computed(() => {
      return /[!@#$%^&*]/.test(passwordForm.password)
    })

    const customStrengthStyle = computed(() => {
      const width = (customStrength.value / 4) * 100
      return {
        width: `${width}%`,
        backgroundColor: customStrengthColor.value
      }
    })

    const customStrengthColor = computed(() => {
      const colors = ['#F56C6C', '#E6A23C', '#409EFF', '#67C23A', '#67C23A'];
      console.log('gggggg',colors[customStrength.value])
      return colors[customStrength.value];
    })

    const customStrengthText = computed(() => {
      const texts = ['非常弱', '弱', '一般', '强', '非常强'];
      return passwordForm.password ? texts[customStrength.value] : '未输入'
    })

    // 自定义强度检查
    const checkCustomStrength = () => {
      if (!passwordForm.password) {
        customStrength.value = 0;
        return;
      }
      let strength = 0;
      // 长度检查
      if (passwordForm.password.length >= 8) strength++;
      if (passwordForm.password.length >= 12) strength++;
      
      // 字符种类检查
      if (hasUpperCase.value && hasLowerCase.value) strength++;
      if (hasNumber.value) strength++;
      if (hasSpecialChar.value) strength++;
      
      // 限制最大强度为4
      customStrength.value = Math.min(strength, 4);
    }

    watch(
      () => props.dialogOpen,
      (newValue) => {
        dialogPassword.value = newValue
        passwordForm.userId = props.params?.userId || null
        console.log('watch', newValue)
      },
      {immediate: true}
    )
    function searchData() {
      context.emit("search");
    }
    function closeDialog() {
      context.emit("close");
    }
    function addNew() {
      context.emit("add");
    }
    const onSubmit = async ()=> {
      passwordFormRef.value && await passwordFormRef.value.validate()
        try {
          await request('changePass', passwordForm)
          ElMessage({
            showClose: true,
            type: "success",
            message: t('system.user.passwordChangeSuccess')
          })
          passwordForm.password = ''
          passwordForm.confirmPass = ''
          context.emit("submit")
      } catch (error) {
        console.error(error)
      }
    }
    return {
      searchData,
      closeDialog,
      addNew,
      onSubmit,
      checkCustomStrength,
      lan,
      dialogPassword,
      passwordForm,
      passwordFormRules,
      passwordFormRef,
      hasUpperCase,
      hasLowerCase,
      hasNumber,
      hasSpecialChar,
      customStrengthStyle,
      customStrengthColor,
      customStrengthText,
      isPasswordValid,
      passExpireDate
    };
  },
};
</script>
<style lang="scss" scoped>
.strength-meter {
  height: 10px;
  background: #eee;
  border-radius: 5px;
  margin: 10px 0;
  overflow: hidden;
  max-width: 500px;
}
.strength-fill {
  height: 100%;
  width: 0%;
  transition: width 0.3s ease;
  border-radius: 5px;
}
.strength-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  font-size: 12px;
  color: #909399;
  max-width: 500px;
}
.strength-text {
  text-align: right;
  font-weight: bold;
  margin-top: 5px;
}

</style>
